import React, { useState, useRef } from 'react';
import './index.css';

function ComboBox(props) {
  const [ menu, setMenu ] = useState(false);
  const width = props.width === null || props.width === undefined ? "100%" : props.width;
  const height = props.height === null || props.height === undefined ? "100%" : props.height;
  const placeholder = props.placeholder === null || props.placeholder === undefined ? "" : props.placeholder;
  const fontSize = props.fontSize === null || props.fontSize === undefined ? "12px" : props.fontSize;
  const background = props.background === null || props.background === undefined ? "white" : props.background;
  const color = props.color === null || props.color === undefined ? "black" : props.color;
  const position = props.position === null || props.position === undefined ? "bottom" : props.position;
  const maxHeight = props.maxHeight === null || props.maxHeight === undefined ? "78px" : props.maxHeight;
  const active = props.active === null || props.active === undefined ? true : props.active;
  const list = props.list;
  const refDiv = useRef(null);

  function handleClick() {
    setMenu(!menu);
  }

  return (
    <div
      onClick={() => active ? handleClick() : null} 
      style={{ width: width, height: '40px', top: '2px', left: '-5px', cursor: active ? 'pointer' : 'cursor', background: '#FFFFFF', borderRadius: '0 15px 15px 0',
        display: active ? 'flex' : 'none', justifyContent: 'space-evenly', alignItems: 'center', position: 'relative'}}>
      <span style={{fontSize: fontSize, color: color }}>{ placeholder }</span>
      { list === null || list === undefined ?
        <></> : 
        <svg xmlns="http://www.w3.org/2000/svg" width="9.433" height="5.716" viewBox="0 0 9.433 5.716">
          <path id="Caminho_151" d="M1871.272,3707.819l3.3,3.3,3.3-3.3" transform="translate(-1869.857 -3706.405)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </svg>
      }
      { list === null || list === undefined ?
        <></> : 
        <div 
          ref={refDiv}
          style={{ display: menu ? 'flex' : 'none' ,background: background, width: width, 
          top: position === "top" ? "-76px" : position === "right" ? "-50px" : "20px", left: position === "right" ? width : "0px",
          border: '0.1px solid #707070', borderRadius: '10px', maxHeight: maxHeight, overflow: 'auto'}}
          className='combobox-item'>
          { list.map(item =>
            <div style={{fontSize: fontSize, color: color, height: '15px' }}
            onClick={() => {
              props.onChange(item);
              setMenu(false);
            }}
            key={Math.random()}
            >{ item }</div>
          )}
        </div>
      }
    </div>
  )
}

export default ComboBox;